import React from "react";
import Modal from "react-modal";

class ProjectCellDetailModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: false
        };

        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    openModal() {
        const disabled = (this.props.disabled === true) || (this.props.immutable === true);
        if (disabled) {
            return;
        }

        this.setState({
            modalIsOpen: true
        });
    }

    afterOpenModal() {
        // optioneel
    }

    closeModal() {
        this.setState({
            modalIsOpen: false
        });

        // Alleen submitten als er een handler is
        if (this.props.onSubmit) {
            this.props.onSubmit();
        }
    }

    onChange(event) {
        if (this.props.onChange) {
            this.props.onChange(event.target.value);
        }
    }

    render() {
        const disabled = (this.props.disabled === true) || (this.props.immutable === true);

        // textarea attributen
        let attr = {};
        if (disabled) {
            attr = { disabled: true, readOnly: true };
        }

        let modalOrNot = null;

        if (this.state.modalIsOpen) {
            modalOrNot = (
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.closeModal}
                    className="modal"
                    overlayClassName="modal-overlay"
                    ariaHideApp={false}
                >
                    <h1>Opmerking</h1>

                    <textarea
                        className="modal-input"
                        autoFocus={true}
                        onChange={this.onChange}
                        value={this.props.value || ""}
                        {...attr}
                    />

                    <div className="float-right m-t-sm">
                        <button className="btn btn-primary" onClick={this.closeModal}>
                            Sluit
                        </button>
                    </div>
                </Modal>
            );
        }

        const contiansCommentClass =
            (this.props.value == null || this.props.value === "")
                ? "contians-no-comment"
                : "contians-comment";

        // Tooltip tekst als disabled
        const titleText = disabled
            ? "Even wachten tot laden/opslaan klaar is"
            : "Opmerking";

        return (
            <div className={"modal-button-container " + contiansCommentClass}>
                <button
                    className="btn-open-modal"
                    onClick={this.openModal}
                    disabled={disabled}
                    title={titleText}
                    type="button"
                >
                    <i className="white fa fa-info" />
                </button>

                {modalOrNot}
            </div>
        );
    }
}

export default ProjectCellDetailModal;